import React from 'react';
import { Navigate } from 'react-router-dom';
import { apiService } from '../services/api';

// Usage is for saved instances only. Temp instances go home.
const SavedInstanceGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (apiService.getInstanceInfo()?.instanceMode !== 'persistent') {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

export default SavedInstanceGate;
